var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextureWrapper',[_vm._t("default"),_c('div',{staticClass:"bg"},[_c('LazyImg',{attrs:{"src":_vm.bg,"fit":'cover'}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }